<template>
  <div class="mine-index">
    <div class="doc-info">
      <div class="avatar"><img :src="userInfo.avatar" alt=""></div>
      <div class="info">
        <div class="name">{{doctorInfo.username}}医生<span>{{doctorInfo.title | jobTitleFilter}}</span></div>
        <div class="company">{{doctorInfo.work_unit}}</div>
        <div class="title">{{doctorInfo.p_dep}} 丨 {{doctorInfo.dep}}</div>
        <div class="id">ID: {{doctorInfo.display_doc_id}}</div>
      </div>
    </div>
    <div class="mine-menu">
      <div class="menu-section">
        <router-link to="/public/test-code" tag="div" class="menu-item" v-if="userInfo.user_id==10032">
          <div class="menu-icon"><icon icon-class="doctor-profile"></icon></div>
          <div class="menu-text">
            <span>测试页面</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>

        <router-link to="/doctor/profile" tag="div" class="menu-item">
          <div class="menu-icon"><icon icon-class="doctor-profile"></icon></div>
          <div class="menu-text">
            <span>个人资料</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>

        <router-link to="/doctor/editcert" tag="div" class="menu-item">
          <div class="menu-icon"><icon icon-class="edit"></icon></div>
          <div class="menu-text">
            <span>完善资质</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>

        <router-link to="/doctor/salary" tag="div" class="menu-item">
          <div class="menu-icon"><icon icon-class="nav-salary"></icon></div>
          <div class="menu-text">
            <span>我的薪资</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
        <router-link to="/doctor/fee-config" tag="div" class="menu-item">
          <div class="menu-icon"><icon icon-class="nav-config"></icon></div>
          <div class="menu-text">
            <span>设置医事服务费</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
        <router-link to="/doctor/coupon" tag="div" class="menu-item" >
          <div class="menu-icon"><img style="width: 17px;margin-left: 3px;" src="@/assets/images/icons/kaquan.png" /></div>
          <div class="menu-text">
            <span>诊疗券</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
        <router-link to="/doctor/appoint" tag="div" class="menu-item" >
          <div class="menu-icon"><img style="width: 17px;margin-left: 3px;" src="@/assets/images/icons/icon-appoint.png" /></div>
          <div class="menu-text">
            <span>加号条</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
      </div>

      <div class="menu-section">
        <router-link to="/doctor/statement" tag="div" class="menu-item">
          <div class="menu-icon"><icon icon-class="nav-law-tip"></icon></div>
          <div class="menu-text">
            <span>法律声明与隐私条款</span>
            <icon icon-class="arrow"></icon>
          </div>
        </router-link>
        <a :href="`tel:${serviceNumber}`" class="menu-item">
          <div class="menu-icon"><icon icon-class="nav-service"></icon></div>
          <div class="menu-text">
            <span>联系客服</span>
            <icon icon-class="arrow"></icon>
          </div>
        </a>
      </div>

    </div>
  </div>
</template>

<style lang="less" scoped>
  .mine-index{
    .doc-info{
      position: relative;
      padding: 28px 20px 40px;
      background: url('@{images-path}/user-bg.png') no-repeat center center;
      background-size: cover;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .avatar{
        width: 56px;
        height: 56px;
        border-radius: 50%;
        border: 2px solid #FFF;
        overflow: hidden;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0px 2px 4px 0px rgba(54,104,166,0.2);
        img{
          width: 100%;
        }
      }
      .info{
        flex: 1;
        margin-left: 16px;
        color: #666;
        font-weight: bold;
        .name{
          width: 100%;
          font-size: 18px;
          line-height: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: flex-end;
          padding: 4px 0 7px;
          border-bottom: 1px solid #E1E7F1;
          span{
            margin-left: 8px;
            color: #666;
            line-height: 14px;
            font-weight: normal;
            font-size: 14px;
            white-space: nowrap;
            padding-bottom: 2px;
          }
        }
        .company{
          font-size: 14px;
          line-height: 20px;
          margin-top: 8px;
          color: @black;
          font-weight: normal;
        }
        .title{
          font-size: 14px;
          line-height: 20px;
          margin-top: 5px;
          color: @black;
          font-weight: normal;
        }
      }
      .id{
        position: absolute;
        bottom: 0;
        right: 16px;
        height: 28px;
        line-height: 28px;
        padding: 0 8px;
        color: #FFF;
        font-size: 14px;
        border-radius: 10px 10px 0 0;
        background: linear-gradient(270deg,rgba(77,140,217,1) 0%,rgba(54,104,166,1) 100%);
      }
    }
    .mine-menu{
      background: #FFF;
      border-radius: 6px 6px 0 0;
      overflow: hidden;
      .menu-section:not(:first-child){
        border-top: 8px solid #EEE;
      }
      .menu-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        padding-left: 20px;
        transition: all .1s;
        &:active{
          background: #F9F9F9;
        }
        .menu-icon{
          width: 22px;
          height: 22px;
          flex-shrink: 0;
          svg{
            font-size: 22px;
            color: @xile;
          }
        }
        .menu-text{
          flex: 1;
          height: 50px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #EEE;
          margin-left: 12px;
          padding-right: 20px;
          span{
            font-size: 15px;
            color: @black;
          }
          svg{
            font-size: 14px;
            color: #CCC;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        doctorInfo: {},
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;

      },
      serviceNumber() {
        return this.$store.state.servicePhone;
      }
    },
    created() {
      console.log(this.userInfo)
      this.$root.post('/getDoctorInfo', {
        user_id: this.userInfo.user_id,
        type: 1,
      }).then(data => {
        this.doctorInfo = data;
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Index/mine.vue